import { TreeViewConstants } from '@/types/constants/TreeViewConstants';
import { Configuration } from '@/types/constants/routes/configuration';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import XPorterConfiguration from '@/views/configuration/xPorter/XPorterConfiguration.vue';

const meta = {
  layout: 'TreeView',
  treePath: '/configuration/xPorter',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'XPorter'
};

export const XPorterRoutes = [
  {
    ...Configuration.XPorter,
    components: {
      default: XPorterConfiguration,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
